<div style="display: flex; align-items: center; gap: 4px; flex-wrap: wrap;">
  <button [ngClass]="configMode == 'basic' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'basic'">
    <span>{{('cau_hinh_co_ban') | translate}}</span>
  </button>

  <button [ngClass]="configMode == 'advanced' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'advanced'">
    <span>{{('cau_hinh_nang_cao') | translate}}</span>
  </button>
</div>
<!-- Cấu hình cơ bản -->
<ng-container *ngIf="configMode == 'basic'">
  <div style="margin-top: 10px">
    <p>{{'tuy_chinh_danh_muc_cha' | translate}}</p>
    <div class="config-text" style="width: 100%">
      <mat-form-field style="width: 100%">
        <mat-label>{{'thay_doi_ten_danh_muc_cha' | translate}}</mat-label>
        <textarea style="padding-top: 7px; height: 50px;" matInput
          [ngModel]="config['category_content']['content_' + functionService.selectedLanguageCode] | vhLanguage : 'content' : objectChoosing.component" 
          (ngModelChange)="config['category_content']['content_' + functionService.selectedLanguageCode] = $event"  
          (blur)="updateContent('content', 'config', {fieldConfig: 'category_content'})"></textarea>
      </mat-form-field>
    </div>

    <p>{{'tuy_chinh_danh_muc_con' | translate}}</p>
    <app-text-format-config [device]="device" [objectChoosing]="objectChoosing" [class]="class" [config]="config"
    [staticdata]="staticdata" [textContentClass]="class['product-category__menu-item--text']"
   [textWrapperClass]="class['product-category__menu-item--text']">
 </app-text-format-config>
  </div>
</ng-container>


<div *ngIf="!isViewAll && configMode == 'advanced'" class="contains-main">
  <ul nz-menu nzMode="inline">
    <li nz-submenu nzTitle="{{'hien_thi' | translate}}" [(nzOpen)]="openMap.menu1" (nzOpenChange)="openHandler('menu1')">
      <div class="main-config">
 
        <!-- Lựa chọn hiển thị cho các thiết bị -->
        <app-hide-show-config [device]="device" [elementChoosing]="objectChoosing">
        </app-hide-show-config>
      </div>
    </li>
   
    <!-- Kiểu hiển thị -->
    <li nz-submenu nzTitle="{{'chon_kieu_hien_thi' | translate}}" [(nzOpen)]="openMap.menu9" (nzOpenChange)="openHandler('menu9')" >
      <nz-select 
        [(ngModel)]="config.type_show" 
        nzPlaceHolder="{{'chon_kieu_hien_thi' | translate}}" 
        (ngModelChange)="changeTypeShow($event)"
      >
        <nz-option nzValue="DropdownSortComponent" nzLabel="{{'sap_xep_mo_rong' | translate}}"></nz-option>
        <nz-option nzValue="HorizontalSortComponent" nzLabel="{{'sap_xep_hang_ngang' | translate}}"></nz-option>
      </nz-select>
    </li>
    
    <ng-container *ngIf="config.type_show == 'DropdownSortComponent'">
      <!-- Tùy chỉnh danh mục cha -->
      <li nz-submenu nzTitle="{{'tuy_chinh_danh_muc_cha' | translate}}" [(nzOpen)]="openMap.menu2" (nzOpenChange)="openHandler('menu2')" >
        <div class="container-font">
          <div class="config-text" style="width: 100%">
            <mat-form-field style="width: 100%">
              <mat-label>{{'thay_doi_ten_danh_muc_cha' | translate}}</mat-label>
              <textarea style="padding-top: 7px; height: 50px;" matInput
                [ngModel]="config['category_content']['content_' + functionService.selectedLanguageCode] | vhLanguage : 'content' : objectChoosing.component" 
                (ngModelChange)="config['category_content']['content_' + functionService.selectedLanguageCode] = $event"  
                (blur)="updateContent('content', 'config', {fieldConfig: 'category_content'})"></textarea>
            </mat-form-field>
          </div>

          <app-text-format-config [device]="device" [objectChoosing]="objectChoosing" [class]="class" [config]="config"
             [staticdata]="staticdata" [textContentClass]="class['product-category__content']"
            [textWrapperClass]="class['product-category__content']">
          </app-text-format-config>
        </div>
        <div class="font-adjusting">
          <div class="row-spacing">
            <span class="title">{{'gian_cach_chu' | translate}}</span>
            <nz-input-number [nzMin]="0" [nzMax]="30" [ngStyle]="{ width: '40%' }" [ngModel]="
                      class['product-category__content']['letter-spacing'] | vhnumber
                  " (nzBlur)="updateClass()" (ngModelChange)="
                      class['product-category__content']['letter-spacing'] =
                      $event + 'px'
                  "></nz-input-number>
          </div>
          <nz-slider [nzMin]="0" [nzMax]="30" [ngModel]="
                  class['product-category__content']['letter-spacing'] | vhnumber
                  " (nzOnAfterChange)="updateClass()" (ngModelChange)="
                  class['product-category__content']['letter-spacing'] =
                      $event + 'px'
                  "></nz-slider>
        </div>
        <!-- Chỉnh khoảng cách giữa danh mục cha và con -->
        <div>
          <div class="config-name">
            <p class="m-0 title">{{'khoang_cach_danh_muc_cha_va_con' | translate}} </p>
            <nz-input-number [ngModel]="class['product-category']['margin-bottom'] | vhnumber"
              (ngModelChange)="class['product-category']['margin-bottom'] = $event + 'px';updateClass()" [nzMin]="0"
              [nzMax]="50" [nzStep]="1">
            </nz-input-number>
          </div>
          <nz-row>
            <nz-col nzSpan="24">
              <nz-slider [ngModel]="class['product-category']['margin-bottom'] | vhnumber"
                (ngModelChange)="class['product-category']['margin-bottom'] = $event + 'px'" (nzOnAfterChange)="updateClass()" [nzMin]="0"
                [nzMax]="50" [nzStep]="1"></nz-slider>
            </nz-col>
          </nz-row>
        </div>
        <div>
          <div class="config-name">
            <p class="w-50">{{'mau_nen' | translate}}</p>
            <input class="input-color w-50" type="button"
              [style.background]="class['product-category']['background-color']"
              [cpOKButton]="true" [(colorPicker)]="class['product-category']['background-color']" (colorPickerClose)="updateClass()"
              [cpPositionRelativeToArrow]="false" />
          </div>
        </div>
        <ul nz-menu nzMode="inline">
          <!-- tùy chỉnh viền danh mục cha-->
          <li nz-submenu nzTitle="{{'kieu_vien_danh_muc_cha' | translate}}" style="padding-left:10px">
            <div class="main-config">
              <app-borders-config [device]="device" [class]="class" [borderClass]="class['product-category']"
                [id_object]="objectChoosing._id" [elementChoosing]="objectChoosing">
              </app-borders-config>
              <!-- Nút mở rộng -->
              <div class="config-name view-more-btn">
                <p (click)="openViewAll(stylefields[0])">{{'mo_rong' | translate}} &#8594;</p>
              </div>
            </div>
          </li>
          <!-- Khoảng đệm cho chữ của danh mục cha-->
          <li nz-submenu nzTitle="{{'khoang_dem_chu' | translate}}" style="padding-left:10px">
            <div class="main-config">
              <app-padding-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
                [classPadding]="class['product-category__content']" [paddingConfigs]="[
                  { type: 'top' },
                  { type: 'bottom' },
                  { type: 'left' },
                  { type: 'right' }
                ]">
              </app-padding-config>
            </div>
          </li>
          <!-- Cấu hình biểu tượng -->
          <li nz-submenu nzTitle="{{'bieu_tuong' | translate}}" style="padding-left:10px">
            <app-symbol-config [device]="device" [class]="class" [config]="config" [symbolClass]="class['product-category']"
              [fontSizeIconClass]="class['product-category__icon']" [symbolConfig]="config['product_category_icon']"
              [objectChoosing]="objectChoosing">
            </app-symbol-config>
          </li>
        </ul>
      </li>

      <!-- Tùy chỉnh danh mục con -->
      <li nz-submenu nzTitle="{{'tuy_chinh_danh_muc_con' | translate}}" [(nzOpen)]="openMap.menu3" (nzOpenChange)="openHandler('menu3')" >
        <div class="container-font">
          <div *ngFor="let data of staticdata['data_sort']; let i = index" class="config-text" style="width: 100%">
            <mat-form-field style="width: 100%">
              <mat-label>{{'thay_doi_ten_danh_muc' | translate}}  {{i + 1}}</mat-label>
              <textarea style="padding-top: 7px; height: 50px;" matInput
                [ngModel]="data['name_' + functionService.selectedLanguageCode] | vhLanguage : data.value : objectChoosing.component" 
                (ngModelChange)="data['name_' + functionService.selectedLanguageCode] = $event"  
                (blur)="updateContent('name', 'data_sort', {indexDataSort: i})"></textarea>
            </mat-form-field>
          </div>

          <app-text-format-config [device]="device" [objectChoosing]="objectChoosing" [class]="class" [config]="config"
             [staticdata]="staticdata" [textContentClass]="class['product-category__menu-item--text']"
            [textWrapperClass]="class['product-category__menu-item--text']">
          </app-text-format-config>
          <div>
            <div class="config-name">
              <p class="w-50">{{'mau_nen' | translate}}</p>
              <input class="input-color w-50" type="button"
                [style.background]="class['product-category__menu-item--border']['background-color']"
                [cpOKButton]="true" [(colorPicker)]="class['product-category__menu-item--border']['background-color']"
                (colorPickerClose)="updateClass()" />
            </div>
          </div>

          

            <!-- Khoảng cách dòng -->
            <div class="mt-2">
              <div class="config-name mb-0">
                <p style="line-height: normal">{{'khoang_cach_dong' | translate}}</p>
                <nz-input-number [nzMin]="0.5" [nzMax]="10" [nzStep]="0.1"
                  [(ngModel)]="class['product-category__menu-item--text']['line-height']" (nzBlur)="updateClass()">
                </nz-input-number>
              </div>
              <nz-row>
                <nz-col nzSpan="24">
                  <nz-slider [nzMin]="0.5" [nzMax]="10" [nzStep]="0.1"
                    [(ngModel)]="class['product-category__menu-item--text']['line-height']" (nzOnAfterChange)="updateClass()">
                  </nz-slider>
                </nz-col>
              </nz-row>
            </div>

            <!-- Khoảng đệm -->
            <app-padding-config
              [objectChoosing]="objectChoosing"
              [device]="device"
              [class]="class"
              [classPadding]="class['product-category__menu-item--border']"
              [paddingConfigs]="[
                { type: 'left' },
                { type: 'right' }
              ]">
            </app-padding-config>
        </div>
        <ul nz-menu nzMode="inline">
          <!-- tùy chỉnh viền danh mục con-->
          <li nz-submenu nzTitle="{{'kieu_vien_danh_muc_con' | translate}}" class="pl-2"
          [(nzOpen)]="openMapSub.submenu8" (nzOpenChange)="openHandler('submenu8', true)">
            <div class="main-config">
              <app-borders-config [device]="device" [class]="class" [elementChoosing]="objectChoosing"
                [borderClass]="class['product-category__menu-item--border']" [id_object]="objectChoosing._id">
              </app-borders-config>
              <!-- Nút mở rộng -->
              <div class="config-name view-more-btn">
                <p (click)="openViewAll(stylefields[1])">{{'mo_rong' | translate}} &#8594;</p>
              </div>
            </div>
          </li>
          <!-- Cấu hình đường viền chung -->
          <li nz-submenu nzTitle="{{'duong_vien_chung' | translate}}" class="pl-2"
          [(nzOpen)]="openMapSub.submenu9" (nzOpenChange)="openHandler('submenu9', true)">
            <app-borders-config 
              [device]="device"
              [class]="class" [elementChoosing]="objectChoosing"
              [borderClass]="class['product-category__menu']"
              [id_object]="objectChoosing._id">
            </app-borders-config>
            <!-- Nút mở rộng -->
            <div class="config-name view-more-btn mt-4">
              <p (click)="openViewAll(stylefields[4])">{{'mo_rong' | translate}} &#8594;</p>
            </div>
          </li>
        </ul>
      </li>
    </ng-container>

    <ng-container *ngIf="config.type_show == 'HorizontalSortComponent'">
      <li nz-submenu nzTitle="{{'cau_hinh_nut_chua_chon' | translate}}" [(nzOpen)]="openMap.menu6" (nzOpenChange)="openHandler('menu6')" >
        <div class="container-font">
          <div *ngFor="let data of staticdata['data_sort']; let i = index" class="config-text" style="width: 100%">
            <mat-form-field style="width: 100%">
              <mat-label>{{'thay_doi_ten_danh_muc' | translate}} {{i + 1}}</mat-label>
              <textarea style="padding-top: 7px; height: 50px;" matInput 
                [(ngModel)]="data.name"
                [ngModel]="data['name_' + functionService.selectedLanguageCode] | vhLanguage : data.value : objectChoosing.component" 
                (ngModelChange)="data['name_' + functionService.selectedLanguageCode] = $event"  
                (blur)="updateContent('name', 'data_sort', {indexDataSort: i})"></textarea>
            </mat-form-field>
          </div>

          <app-text-format-config [device]="device" [objectChoosing]="objectChoosing" [class]="class" [config]="config"
             [staticdata]="staticdata" [textContentClass]="class['-sort-list__item--inner']"
            [textWrapperClass]="class['-sort-list__item--inner']">
          </app-text-format-config>
          <div>
            <div class="config-name">
              <p class="w-50">{{'mau_nen' | translate}}</p>
              <input class="input-color w-50" type="button"
                [style.background]="class['-sort-list__item--inner']['background-color']"
                [cpOKButton]="true" [(colorPicker)]="class['-sort-list__item--inner']['background-color']"
                (colorPickerClose)="updateClass()" />
            </div>
          </div>

            <!-- Khoảng cách dòng -->
            <div class="mt-2">
              <div class="config-name mb-0">
                <p>{{'khoang_cach_dong' | translate}}</p>
                <nz-input-number [nzMin]="0.5" [nzMax]="10" [nzStep]="0.1"
                  [(ngModel)]="class['-sort-list__item--inner']['line-height']" (nzBlur)="updateClass()">
                </nz-input-number>
              </div>
              <nz-row>
                <nz-col nzSpan="24">
                  <nz-slider [nzMin]="0.5" [nzMax]="10" [nzStep]="0.1"
                    [(ngModel)]="class['-sort-list__item--inner']['line-height']" (nzOnAfterChange)="updateClass()">
                  </nz-slider>
                </nz-col>
              </nz-row>
            </div>

             <!-- Khoảng cách giữa các nút -->
             <div class="mt-2">
              <div class="config-name mb-0">
                <p>{{'khoang_cach_giua_cac_nut' | translate}}</p>
                <nz-input-number 
                  [nzMin]="0" 
                  [ngModel]="class['sort-list']['gap'] | vhnumber" 
                  (nzBlur)="updateClass()" 
                  (ngModelChange)="class['sort-list']['gap'] =$event + 'px'" 
                >
                </nz-input-number>
              </div>
              <nz-row>
                <nz-col nzSpan="24">
                  <nz-slider 
                    [nzMin]="0" 
                    [ngModel]="class['sort-list']['gap'] | vhnumber" 
                    (nzOnAfterChange)="updateClass()" 
                    (ngModelChange)="class['sort-list']['gap'] =$event + 'px'"
                  >
                  </nz-slider>
                </nz-col>
              </nz-row>
            </div>
        </div>
        <ul nz-menu nzMode="inline">
          <!-- tùy chỉnh viền-->
          <li nz-submenu nzTitle="{{'kieu_vien' | translate}}" style="padding-left: 10px;"
          [(nzOpen)]="openMapSub.submenu6" (nzOpenChange)="openHandler('submenu6', true)">
            <div class="main-config">
              <app-borders-config [device]="device" [class]="class" [elementChoosing]="objectChoosing"
                [borderClass]="class['-sort-list__item--inner']" [id_object]="objectChoosing._id">
              </app-borders-config>
              <!-- Nút mở rộng -->
              <div class="config-name view-more-btn">
                <p (click)="openViewAll(stylefields[2])">{{'mo_rong' | translate}} &#8594;</p>
              </div>
            </div>
          </li>
          <!-- khoảng đệm-->
          <li nz-submenu nzTitle="{{'khoang_dem' | translate}}" style="padding-left: 10px;"
          [(nzOpen)]="openMapSub.submenu7" (nzOpenChange)="openHandler('submenu7', true)">
            <app-padding-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
              [classPadding]="class['-sort-list__item--inner']" [paddingConfigs]="[
                { type: 'top' },
                { type: 'bottom' },
                { type: 'left' },
                { type: 'right' }
              ]">
            </app-padding-config>
          </li>
        </ul>
      </li>

      <li nz-submenu nzTitle="{{'cau_hinh_nut_da_chon' | translate}}" [(nzOpen)]="openMap.menu7" (nzOpenChange)="openHandler('menu7')" >
        <div class="container-font">
          <app-text-format-config [device]="device" [objectChoosing]="objectChoosing" [class]="class" [config]="config"
             [staticdata]="staticdata" [textContentClass]="class['+sort-list__item--inner']"
            [textWrapperClass]="class['+sort-list__item--inner']">
          </app-text-format-config>
          <div>
            <div class="config-name">
              <p class="w-50">{{'mau_nen' | translate}}</p>
              <input class="input-color w-50" type="button"
                [style.background]="class['+sort-list__item--inner']['background-color']"
                [cpOKButton]="true" [(colorPicker)]="class['+sort-list__item--inner']['background-color']"
                (colorPickerClose)="updateClass()" />
            </div>
          </div>

            <!-- Khoảng cách dòng -->
            <div class="mt-2">
              <div class="config-name mb-0">
                <p>{{'khoang_cach_dong' | translate}}</p>
                <nz-input-number [nzMin]="0.5" [nzMax]="10" [nzStep]="0.1"
                  [(ngModel)]="class['+sort-list__item--inner']['line-height']" (nzBlur)="updateClass()">
                </nz-input-number>
              </div>
              <nz-row>
                <nz-col nzSpan="24">
                  <nz-slider [nzMin]="0.5" [nzMax]="10" [nzStep]="0.1"
                    [(ngModel)]="class['+sort-list__item--inner']['line-height']" (nzOnAfterChange)="updateClass()">
                  </nz-slider>
                </nz-col>
              </nz-row>
            </div>

             <!-- Khoảng cách giữa các nút -->
             <div class="mt-2">
              <div class="config-name mb-0">
                <p>{{'khoang_cach_giua_cac_nut' | translate}}</p>
                <nz-input-number 
                  [nzMin]="0" 
                  [ngModel]="class['sort-list']['gap'] | vhnumber" 
                  (nzBlur)="updateClass()" 
                  (ngModelChange)="class['sort-list']['gap'] =$event + 'px'" 
                >
                </nz-input-number>
              </div>
              <nz-row>
                <nz-col nzSpan="24">
                  <nz-slider 
                    [nzMin]="0" 
                    [ngModel]="class['sort-list']['gap'] | vhnumber" 
                    (nzOnAfterChange)="updateClass()" 
                    (ngModelChange)="class['sort-list']['gap'] =$event + 'px'"
                  >
                  </nz-slider>
                </nz-col>
              </nz-row>
            </div>
        </div>
        <ul nz-menu nzMode="inline">
          <!-- tùy chỉnh viền-->
          <li nz-submenu nzTitle="{{'kieu_vien' | translate}}" style="padding-left: 10px;"
          [(nzOpen)]="openMapSub.submenu4" (nzOpenChange)="openHandler('submenu4', true)">
            <div class="main-config">
              <app-borders-config [device]="device" [class]="class" [elementChoosing]="objectChoosing"
                [borderClass]="class['+sort-list__item--inner']" [id_object]="objectChoosing._id">
              </app-borders-config>
              <!-- Nút mở rộng -->
              <div class="config-name view-more-btn">
                <p (click)="openViewAll(stylefields[3])">{{'mo_rong' | translate}} &#8594;</p>
              </div>
            </div>
          </li>
          <!-- khoảng đệm-->
          <li nz-submenu nzTitle="{{'khoang_dem' | translate}}" style="padding-left: 10px;"
          [(nzOpen)]="openMapSub.submenu5" (nzOpenChange)="openHandler('submenu5', true)">
            <app-padding-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
              [classPadding]="class['+sort-list__item--inner']" [paddingConfigs]="[
                { type: 'top' },
                { type: 'bottom' },
                { type: 'left' },
                { type: 'right' }
              ]">
            </app-padding-config>
          </li>
        </ul>
      </li>

      <!-- Nút Radio -->
      <li nz-submenu nzTitle="{{'nut_radio' | translate}}" [(nzOpen)]="openMap.menu8" (nzOpenChange)="openHandler('menu8')" >
        <div class="my-2">
          <div class="config-name">
            <span class="w-50">{{ 'dung_nut_radio' | translate}}</span>
            <nz-switch [(ngModel)]="config['is_radio']" (ngModelChange)="updateConfig()">
            </nz-switch>
          </div>

          <ng-container *ngIf="config?.['is_radio']">
            <!-- Khoảng cách giữa nút radio với chữ -->
            <div class="config-name mt-2 flex-wrap">
              <div class="slide-bar">
                <p class="m-0 title">{{'khoang_cach_giua_radio_va_chu' | translate}}</p>
                <nz-input-number [ngModel]="class['sort-list__item']['gap'] | vhnumber" (nzBlur)="updateClass()" style="width: 40%"
                  (ngModelChange)="class['sort-list__item']['gap'] = $event + 'px'"></nz-input-number>
              </div>
              <nz-slider [ngModel]="class['sort-list__item']['gap'] | vhnumber" (nzOnAfterChange)="updateClass()"
                (ngModelChange)="class['sort-list__item']['gap'] = $event + 'px'" style="width: 100%"></nz-slider>
            </div>
            <!-- Vị trí của nút so với chiều cao của chữ -->
            <div class="config-name mt-2 flex-wrap" style="gap: 0px">
              <p>{{ "vi_tri_cua_nut_so_voi_chieu_cao_cua_chu" | translate }}</p>
              <div class="d-flex">
                <button nz-button class="flex border border-right-0"
                  [nzType]="class['sort-list__item']['align-items'] == 'flex-start' ? 'primary' : 'default'"
                  (click)="handleSetAlign('align-items', 'flex-start', 'sort-list__item')">
                  <span class="item__sidebar--text">{{'tren' | translate}}</span>
                </button>
                <button nz-button class="flex border border-right-0"
                  [nzType]=" class['sort-list__item']['align-items'] == 'center' ? 'primary' : 'default' "
                  (click)=" handleSetAlign('align-items', 'center', 'sort-list__item')">
                  <span class="item__sidebar--text">{{'giua' | translate}}</span>
                </button>
                <button nz-button class="flex border"
                  [nzType]="class['sort-list__item']['align-items'] == 'flex-end'? 'primary': 'default'"
                  (click)="handleSetAlign('align-items', 'flex-end', 'sort-list__item')">
                  <span class="item__sidebar--text">{{'duoi' | translate}}</span>
                </button>
              </div>
            </div>
          </ng-container>
        </div>
      </li>

      <!-- Cấu hình nút radio khi chọn và chưa chọn -->
      <ng-container *ngIf="config?.['is_radio']">
        <!-- Nút radio khi chọn -->
        <li nz-submenu nzTitle="{{'nut_radio_khi_chon' | translate}}" [(nzOpen)]="openMap.menu11" (nzOpenChange)="openHandler('menu11')">
          <!-- Chiều dài -->
          <div class="config-name mt-2 flex-wrap">
            <div class="d-flex justify-content-between">
              <p class="m-0 title">{{'chieu_dai' | translate}}</p>
              <nz-input-number [ngModel]="class['+sort-list__item--radio']['width'] | vhnumber" (nzBlur)="updateClass()" style="width: 40%"
                (ngModelChange)="class['+sort-list__item--radio']['width'] = $event + 'px'"></nz-input-number>
            </div>
            <nz-slider [ngModel]="class['+sort-list__item--radio']['width'] | vhnumber" (nzOnAfterChange)="updateClass()"
              (ngModelChange)="class['+sort-list__item--radio']['width'] = $event + 'px'" style="width: 100%"></nz-slider>
          </div>
          <!-- Chiều cao -->
          <div class="config-name mt-2 flex-wrap">
            <div class="d-flex justify-content-between">
              <p class="m-0 title">{{'chieu_cao' | translate}}</p>
              <nz-input-number [ngModel]="class['+sort-list__item--radio']['height'] | vhnumber" (nzBlur)="updateClass()" style="width: 40%"
                (ngModelChange)="class['+sort-list__item--radio']['height'] = $event + 'px'"></nz-input-number>
            </div>
            <nz-slider [ngModel]="class['+sort-list__item--radio']['height'] | vhnumber" (nzOnAfterChange)="updateClass()"
              (ngModelChange)="class['+sort-list__item--radio']['height'] = $event + 'px'" style="width: 100%"></nz-slider>
          </div>
          <!-- Màu -->
          <div class="config-name my-2">
            <p class="w-50">{{'mau' | translate}}</p>
            <input class="input-color w-50" type="button"
              [style.background]="class['+sort-list__item--radio']['background-color']"
              [cpOKButton]="true" [(colorPicker)]="class['+sort-list__item--radio']['background-color']"
              (colorPickerClose)="updateClass()" />
          </div>
          <ng-container>
            <!-- Viền -->
            <li nz-submenu nzTitle="{{'kieu_vien' | translate}}" [(nzOpen)]="openMapSub.submenu1" (nzOpenChange)="openHandler('submenu1', true)">
              <app-borders-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
                [borderClass]="class['+sort-list__item--radio']" [id_object]="objectChoosing._id">
              </app-borders-config>
            </li>
            <!-- Bo tròn -->
            <li nz-submenu nzTitle="{{'bo_tron' | translate}}" [(nzOpen)]="openMapSub.submenu2" (nzOpenChange)="openHandler('submenu2', true)">
              <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
                [borderRadiusClass]="class['+sort-list__item--radio']" [id_object]="objectChoosing._id">
              </app-borders-radius-config>
            </li>
            <!-- Viền -->
            <li nz-submenu nzTitle="{{'do_bong' | translate}}" [(nzOpen)]="openMapSub.submenu3" (nzOpenChange)="openHandler('submenu3', true)">
              <app-shadow-config [device]="device" [config]="config" [class]="class" [shadowClass]="class['+sort-list__item--radio']"
                [shadowConfig]="config['+sort_list_item_radio']['box-shadow']" [objectChoosing]="objectChoosing">
              </app-shadow-config>
            </li>
          </ng-container>
        </li>
        <!-- Nút radio khi chưa chọn -->
        <li nz-submenu nzTitle="{{'nut_radio_khi_chua_chon' | translate}}" [(nzOpen)]="openMap.menu12" (nzOpenChange)="openHandler('menu12')">
          <!-- Chiều dài -->
          <div class="config-name mt-2 flex-wrap">
            <div class="d-flex justify-content-between">
              <p class="m-0 title">{{'chieu_dai' | translate}}</p>
              <nz-input-number [ngModel]="class['-sort-list__item--radio']['width'] | vhnumber" (nzBlur)="updateClass()" style="width: 40%"
                (ngModelChange)="class['-sort-list__item--radio']['width'] = $event + 'px'"></nz-input-number>
            </div>
            <nz-slider [ngModel]="class['-sort-list__item--radio']['width'] | vhnumber" (nzOnAfterChange)="updateClass()"
              (ngModelChange)="class['-sort-list__item--radio']['width'] = $event + 'px'" style="width: 100%"></nz-slider>
          </div>
          <!-- Chiều cao -->
          <div class="config-name mt-2 flex-wrap">
            <div class="d-flex justify-content-between">
              <p class="m-0 title">{{'chieu_cao' | translate}}</p>
              <nz-input-number [ngModel]="class['-sort-list__item--radio']['height'] | vhnumber" (nzBlur)="updateClass()" style="width: 40%"
                (ngModelChange)="class['-sort-list__item--radio']['height'] = $event + 'px'"></nz-input-number>
            </div>
            <nz-slider [ngModel]="class['-sort-list__item--radio']['height'] | vhnumber" (nzOnAfterChange)="updateClass()"
              (ngModelChange)="class['-sort-list__item--radio']['height'] = $event + 'px'" style="width: 100%"></nz-slider>
          </div>
          <!-- Màu -->
          <div class="config-name my-2">
            <p class="w-50">{{'mau' | translate}}</p>
            <input class="input-color w-50" type="button"
              [style.background]="class['-sort-list__item--radio']['background-color']"
              [cpOKButton]="true" [(colorPicker)]="class['-sort-list__item--radio']['background-color']"
              (colorPickerClose)="updateClass()" />
          </div>
          <ng-container>
            <!-- Viền -->
            <li nz-submenu nzTitle="{{'kieu_vien' | translate}}" [(nzOpen)]="openMapSub.submenu11" (nzOpenChange)="openHandler('submenu11', true)">
              <app-borders-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
                [borderClass]="class['-sort-list__item--radio']" [id_object]="objectChoosing._id">
              </app-borders-config>
            </li>
            <!-- Bo tròn -->
            <li nz-submenu nzTitle="{{'bo_tron' | translate}}" [(nzOpen)]="openMapSub.submenu12" (nzOpenChange)="openHandler('submenu12', true)">
              <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
                [borderRadiusClass]="class['-sort-list__item--radio']" [id_object]="objectChoosing._id">
              </app-borders-radius-config>
            </li>
            <!-- Viền -->
            <li nz-submenu nzTitle="{{'do_bong' | translate}}" [(nzOpen)]="openMapSub.submenu13" (nzOpenChange)="openHandler('submenu13', true)">
              <app-shadow-config [device]="device" [config]="config" [class]="class" [shadowClass]="class['-sort-list__item--radio']"
                [shadowConfig]="config['-sort_list_item_radio']['box-shadow']" [objectChoosing]="objectChoosing">
              </app-shadow-config>
            </li>
          </ng-container>
        </li>
      </ng-container>
    </ng-container>
    
    <!-- Cấu hình xuống dòng -->
    <li *ngIf="config.type_show == 'HorizontalSortComponent'" nz-submenu nzTitle="{{'cau_hinh_xuong_dong' | translate}}"
      [(nzOpen)]="openMap.menu10" (nzOpenChange)="openHandler('menu10')" >
      <div class="main-config">
        <div class="config-name">
          <span class="w-50">{{ 'xuong_dong' | translate}}</span>
          <nz-switch [(ngModel)]="isWrap" (ngModelChange)="handleSetWrap()">
          </nz-switch>
        </div>

        <div class="config-name my-2">
          <span class="w-50">{{ 'gian_deu' | translate}}</span>
          <nz-switch [(ngModel)]="isEvenly" (ngModelChange)="handleSetEvenly()">
          </nz-switch>
        </div>

        <div *ngIf="isWrap && !isEvenly" class="config-name mb-2" style="gap: 0;">
          <button nz-button class="flex border border-right-0"
            [nzType]="class['sort-list']['justify-content'] == 'flex-start' ? 'primary' : 'default'"
            (click)="handleSetAlign('justify-content', 'flex-start')">
            <span class="item__sidebar--text">{{'trai' | translate}}</span>
          </button>
          <button nz-button class="flex border border-right-0"
            [nzType]=" class['sort-list']['justify-content'] == 'center' ? 'primary' : 'default' "
            (click)=" handleSetAlign('justify-content', 'center')">
            <span class="item__sidebar--text">{{'giua' | translate}}</span>
          </button>
          <button nz-button class="flex border"
            [nzType]="class['sort-list']['justify-content'] == 'flex-end'? 'primary': 'default'"
            (click)="handleSetAlign('justify-content', 'flex-end')">
            <span class="item__sidebar--text">{{'phai' | translate}}</span>
          </button>
        </div>
      </div>
    </li>
    <!-- HIỆU ỨNG DANH MỤC CHA -->
    <li (nzOpenChange)="openHandler('menu14')" [(nzOpen)]="openMap.menu14" nz-submenu
    nzTitle="{{((config.type_show == 'DropdownSortComponent') ? 'hieu_ung_danh_muc_cha' : 'hieu_ung') | translate}}">
      <app-choose-animations-config [elementChoosing]="objectChoosing" (openAnimationDetail)="openAnimationDetail($event)"
        [id_object]="objectChoosing._id" [device]="device" [class]="class" [config]="config" [staticdata]="staticdata"
        [cursorClass]="class[(config.type_show == 'DropdownSortComponent') ? 'product-category' : 'sort-list__item']"
        [effect_hover]="effect_hover" [customize]="customize" [type]="'object'" [effectFileUsing]="'sort-product'">
      </app-choose-animations-config>
    </li>

    <ng-container *ngIf="config.type_show == 'DropdownSortComponent'">
      <!-- HIỆU ỨNG DANH MỤC CON-->
      <li (nzOpenChange)="openHandler('menu22')" [(nzOpen)]="openMap.menu22" nz-submenu nzTitle="{{'hieu_ung_danh_muc_con' | translate}}">
        <app-choose-animations-config [elementChoosing]="objectChoosing" (openAnimationDetailChild)="openAnimationDetailChild($event)"
          [id_object]="objectChoosing._id" [device]="device" [class]="class" [config]="config" [staticdata]="staticdata"
          [cursorClass]="class['product-category__menu-item--text']" [effect_hover]="effect_hover" [customize]="customize" [type]="'object'"
          [isParent]="false" [effectFileUsing]="'sort-product'">
        </app-choose-animations-config>
      </li>
      <!-- HIỆU ỨNG XUẤT HIỆN DANH MỤC CON -->
      <li (nzOpenChange)="openAnimationAppear(); openHandler('menu15')" nz-submenu
      nzTitle="{{'hieu_ung_xuat_hien_muc_con' | translate}}" [(nzOpen)]="openMap.menu15">
        <app-animations-config [elementChoosing]="objectChoosing" [staticdata]="staticdata" [id_object]="objectChoosing._id" [customize]="customize"
          [device]="device">
        </app-animations-config>
      </li>
    </ng-container>
  </ul>
</div>

<div class="editor-header" *ngIf="isViewAll">
  <div class="return" (click)="isViewAll = !isViewAll" style="
      display: flex;
      align-items: center;
      gap: 10px;
      cursor: pointer;
      margin-bottom: 5px;
      text-transform: uppercase;
      border-bottom: 1px solid #cddd;
    ">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll" style="font-weight: 500;">
      {{currentViewAll.title | translate}}</span>
  </div>
</div>
<div class="view-more" *ngIf="isViewAll">
  <!-- Cấu hình chi tiết viền danh muc cha-->
  <div class="view_more-border" *ngIf="currentViewAll.index == 1">
    <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device" [class]="class" [borderRadiusClass]="class['product-category']"
      [id_object]="objectChoosing._id">
    </app-borders-radius-config>
  </div>
  <!-- tùy chỉnh viền danh mục con -->
  <div class="view_more-border" *ngIf="currentViewAll.index == 2">
    <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
      [borderRadiusClass]="class['product-category__menu-item--border']" [id_object]="objectChoosing._id">
    </app-borders-radius-config>
  </div>

    <!-- tùy chỉnh viền nút chưa chọn kiểu hiển thị 2 -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 3">
      <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
        [borderRadiusClass]="class['-sort-list__item--inner']" [id_object]="objectChoosing._id">
      </app-borders-radius-config>
    </div>

    <!-- tùy chỉnh viền nút đã chọn kiểu hiển thị 2 -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 4">
      <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
        [borderRadiusClass]="class['+sort-list__item--inner']" [id_object]="objectChoosing._id">
      </app-borders-radius-config>
    </div>

    <!-- tùy chỉnh viền Đường viền chung -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 5">
      <app-borders-radius-config  
      [elementChoosing]="objectChoosing"
        [id_object]="objectChoosing._id"
        [device]="device" 
        [class]="class"
        [borderRadiusClass]="class['product-category__menu']">
      </app-borders-radius-config>
    </div>

    <!-- Cấu hình chi tiết hiệu ứng -->
    <div class="editor_effect-hover" *ngIf="currentViewAll.index == 6 ||currentViewAll.index == 7 ">
      <app-animations-config [elementChoosing]="objectChoosing" [staticdata]="staticdata" [id_object]="objectChoosing._id" [customize]="customize"
        [device]="device" [isParent]="currentViewAll.index == 6"></app-animations-config>
    </div>
</div>